import Progress from '../vendors/progress.min';

export default function progressIndicator () {
    const singlePost = $('.single-post');
    const progressBar = $('.progress-indicator');

    if (singlePost.length && progressBar.length) {
        Progress.init();
    }
}



// WEBPACK FOOTER //
// ./front/bankomania/js/modules/read-progress.js